import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getByRegister(register_id: string | number) {
  const response = await http
    .getData(`/register/${register_id}/rekonsiliasi-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

async function create(data:any) {
  const response = await http.postData("/rekonsiliasi-obat", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function update(id: number,data: any) {
  const response = await http
    .putData(`/rekonsiliasi-obat/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/rekonsiliasi-obat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getDaftarObat(register_id: string | number) {
  const response = await http
    .getData(`/rekonsiliasi-obat/${register_id}/transaksi-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

async function getUnverif(register_id: string | number) {
  const response = await http
    .getData(`/rekonsiliasi-obat/${register_id}/unverified`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

async function verif(data: any) {
  const response = await http
    .putData(`/verifikasi/rekonsiliasi-obat`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function addItem(id: number, data: any) {
  const response = await http
    .postData(`/rekonsiliasi-obat/${id}/item`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function updateItem(id: number, itemId: number, data: any) {
  const response = await http
    .putData(`/rekonsiliasi-obat/${id}/item/${itemId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function deleteItem(id: number, itemId: number) {
  const response = await http
    .deleteData(`/rekonsiliasi-obat/${id}/item/${itemId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function pushToCpo(id: number) {
  const response = await http
    .postData(`/rekonsiliasi-obat/${id}/push-to-cpo`, {})
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function sign(id: number, data: { role: string; password: string }) {
  const response = await http
    .postData(`/rekonsiliasi-obat/${id}/sign`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/rekonsiliasi-obat/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  create,
  update,
  destroy,
  getDaftarObat,
  getUnverif,
  verif,
  addItem,
  updateItem,
  deleteItem,
  pushToCpo,
  sign,
  printPdf
};
